import { Box } from "@mui/material";

interface NavBarButtonWrapperProps {
  isActive: boolean;
  children: React.ReactNode;
}

export function NavBarButtonWrapper({
  isActive,
  children,
}: NavBarButtonWrapperProps) {
  return (
    <Box
      sx={{
        borderLeft: isActive ? "3px solid #4caf50" : "3px solid transparent",
        borderRadius: "4px 0 0 4px",
      }}
    >
      {children}
    </Box>
  );
}
